module.exports = __webpack_public_path__ + "static/media/yeti-banner.3222e650.png";